/**
 * @generated SignedSource<<3c6cba84ad708f29995bf6eb310ac9a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type snapshotSaveMutation$variables = {
  refundId: string;
  snapshotData: string;
  type: string;
};
export type snapshotSaveMutation$data = {
  readonly createApplyRefundCertificate: {
    readonly message: string;
    readonly result: boolean;
  };
};
export type snapshotSaveMutation = {
  response: snapshotSaveMutation$data;
  variables: snapshotSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "snapshotData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      },
      {
        "kind": "Variable",
        "name": "snapshotData",
        "variableName": "snapshotData"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "CreateApplyCertificationOutput",
    "kind": "LinkedField",
    "name": "createApplyRefundCertificate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "snapshotSaveMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "snapshotSaveMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fb28d441a7b4c7fe0a23fa9ac38c5702",
    "id": null,
    "metadata": {},
    "name": "snapshotSaveMutation",
    "operationKind": "mutation",
    "text": "mutation snapshotSaveMutation(\n  $type: String!\n  $refundId: String!\n  $snapshotData: String!\n) {\n  createApplyRefundCertificate(type: $type, refundId: $refundId, snapshotData: $snapshotData) {\n    result\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "1924d9dc72034177b8690189b3c0d077";

export default node;
